import reactUpdate from 'immutability-helper';
import _ from 'underscore';

import * as EventConstants from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import Store from 'lib/Store';

class ApplicableBatchesStore extends Store {
  // Stores the batches that can be used as batch link fields when creating a batch for a file.
  resetState() {
    this.applicableBatchesByFile = {};
  }

  getApplicableBatches(fileId, batchLinkFieldId) {
    return this.applicableBatchesByFile[fileId]
      ? this.applicableBatchesByFile[fileId][batchLinkFieldId]
      : null;
  }

  payloadHandler(action) {
    switch (action.actionType) {
      case EventConstants.APPLICABLE_BATCHES_FETCH_COMPLETED: {
        const {fileId, batchLinkFieldId, batches} = action;
        if (!this.applicableBatchesByFile[fileId]) {
          this.applicableBatchesByFile[fileId] = {};
        }

        this.applicableBatchesByFile = reactUpdate(this.applicableBatchesByFile, {
          [fileId]: {[batchLinkFieldId]: {$set: batches}},
        });

        this.emitChange();
        break;
      }
      case EventConstants.FILE_TAGS_UPDATED: {
        const {tagData} = action;
        // eslint-disable-next-line no-restricted-syntax
        const fileIds = _.pluck(tagData, 'id');
        fileIds.forEach((fileId) => {
          this.applicableBatchesByFile[fileId] = null;
        });
        this.emitChange();
        break;
      }
      default:
        break;
    }
  }
}

const applicableBatchesStore = new ApplicableBatchesStore(AppDispatcher);
export default applicableBatchesStore;
